export default __webpack_public_path__ + "static/media/trash.920fa0a3.svg";